import { Box, ButtonBase, useTheme, IconButton, Drawer, Typography, List, ListItem, ListItemButton, ListItemText, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Close Icon
import MenuIcon from "@mui/icons-material/Menu"; // Mobile Menu Icon
import { useState } from "react";

// project imports
import LogoSection from "./logo/index";
import { useNavigate } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";

function Header() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Detect mobile screen size
  const [mobileOpen, setMobileOpen] = useState(false); // State for drawer menu

  // Toggle Mobile Menu
  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev); // Toggle correctly
  };

  // Close Mobile Menu and Navigate (Ensures Immediate Closure)
  const handleMenuClick = (path: string) => {
    setMobileOpen(false); // Close menu first
    setTimeout(() => navigate(path), 100); // Ensure it stays closed
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 0px",
          background: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            borderRadius: "10px",
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <LogoSection />
            <Typography variant="h2" sx={{ fontWeight: "bold", color: theme.palette.text.primary }}>
              Out In Service
            </Typography>
          </Box>

          {/* Desktop Menu */}
          {!isMobile && (
            <Box sx={{ display: "flex", gap: 3, mr: 3 }}>
              <ButtonBase onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.ABOUT)}>
                <strong>About</strong>
              </ButtonBase>
              <ButtonBase onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.HOWTO)}>
                <strong>How To</strong>
              </ButtonBase>
              <ButtonBase onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.CONTACT)}>
                <strong>Contact Us</strong>
              </ButtonBase>
              <ButtonBase onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.Donate)}>
                <strong>Donate</strong>
              </ButtonBase>
              <ButtonBase onClick={() => handleMenuClick("/login")}>
                <strong>Login</strong>
              </ButtonBase>
            </Box>
          )}

          {/* Mobile Menu (Hamburger Icon) */}
          {isMobile && (
            <IconButton onClick={handleDrawerToggle} sx={{ ml: 1 }}>
              <MenuIcon />
            </IconButton>
          )}

          {/* Mobile Drawer Menu */}
          <Drawer
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              "& .MuiDrawer-paper": { width: 250, background: theme.palette.background.paper },
            }}
          >
            {/* Close Button at the Top */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
              <LogoSection />
              <IconButton onClick={handleDrawerToggle}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Menu Items */}
            <List>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.ABOUT)}>
                  <ListItemText primary="About" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.HOWTO)}>
                  <ListItemText primary="How To" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.CONTACT)}>
                  <ListItemText primary="Contact Us" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleMenuClick(ROUTE_NAMES.FRONT_ROUTES.Donate)}>
                  <ListItemText primary="Donate" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleMenuClick("/login")}>
                  <ListItemText primary="Login" />
                </ListItemButton>
              </ListItem>
            </List>
          </Drawer>
        </Box>
      </Box>
    </>
  );
}

export default Header;

